'use client';

import { Button, Menu, MenuItem } from '@mui/material';
import React, { useId, useState } from 'react';
import { useTranslations } from 'next-intl';
import { regions } from './region';

export function RegionSelector() {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const t = useTranslations('Region');

  const id = useId();
  const buttonId = `region-selector-button-${id}`;
  const menuId = `region-selector-menu-${id}`;

  return (
    <>
      <Button
        variant={'outlined'}
        color={'primary'}
        id={buttonId}
        aria-controls={open ? menuId : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        sx={{
          backgroundColor: 'transparent',
          fontWeight: 400,
          textTransform: 'none',
          color: 'common.white',
          borderColor: 'common.white',
          '&:hover': {
            backgroundColor: 'transparent !important',
            color: 'primary.main',
            borderColor: 'primary.main',
          },
        }}
      >
        {t('region')}
      </Button>
      <Menu
        id={menuId}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': buttonId,
        }}
      >
        {regions.map(reg => {
          return (
            <MenuItem
              key={reg}
              component={'a'}
              href={`/switch-region?region=${reg}`}
              sx={{ minWidth: '8rem', justifyContent: 'center' }}
            >
              {t(reg as never)}
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
}
